<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Name</label>
          <input :class="{'input': true, 'is-danger': errors.has('name'), 'is-disabled': inProgress}" type="text" name="name" id="name" placeholder="Name" v-model="user.name" v-validate data-vv-rules="required">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
        <p class="control">
          <label class="label">Email</label>
          <input :class="{'input': true, 'is-danger': errors.has('email'), 'is-disabled': inProgress}" type="email" name="email" id="email" placeholder="Email" v-model="user.email" v-validate data-vv-rules="required|email">
          <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
        </p>
        <p class="control">
          <label class="label">Password</label>
          <input :class="{'input': true, 'is-danger': errors.has('password'), 'is-disabled': inProgress, 'password': true}" type="password" name="password" id="password" placeholder="Password" v-model="user.password" v-validate data-vv-rules="required">
          <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
        </p>
        <p class="control">
          <label class="label">Department</label>
          <select class="select is-fullwidth" v-model="user.departament" name="departament" id="departament">
            <option v-for="departament in context.$store.state.config.departaments" v-bind:value="departament.id">{{ departament.name }}</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Level</label>
          <select class="select is-fullwidth" v-model="user.level" name="level" id="level">
            <option v-for="level in context.$store.state.config.users.level" v-bind:value="level.id" v-if="level.id >= 1 && level.id <= 3">{{ level.name }}</option>
          </select>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.occurrences">
            Tickets
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.reconfirmations">
            Reconfirmation
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.extend_card">
            Extend Card
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.move_service_po">
            Move Service - Payment Order
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.delete_service_po">
            Delete Service - Payment Order
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.revert_payment">
              Revert Payment - Payment Order
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.move_service_invoice">
            Move Service - Invoice
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.delete_service_invoice">
            Delete Service - Invoice
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.validate_charges">
            Validate Charges
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.generate_boleto">
            Generate Boleto
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.occurrence_config">
            Ticket Config
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.dispute_payment">
            Dispute Payment
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="user.refunds_po">
            Refunds PO
          </label>
        </p>
        <p class="control">
          <label class="label">Telephone Extension</label>
          <input :class="{'input': true, 'is-disabled': inProgress}" type="text" name="telephone_extension" id="telephone_extension" placeholder="" v-model="user.telephone_extension">
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any(), 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      user_id: {
        type: Number
      }
    },
    data () {
      return {
        user: {
          name: '',
          email: '',
          cangooroo_user: '',
          cangooroo_password: '',
          password: '',
          agency: 0,
          departament: 0,
          level: 1,
          occurrences: false,
          reconfirmations: false,
          extend_card: false,
          move_service_po: false,
          delete_service_po: false,
          revert_payment: false,
          move_service_invoice: false,
          delete_service_invoice: false,
          validate_charges: false,
          generate_boleto: false,
          occurrence_config: false,
          dispute_payment: false,
          refunds_po: false,
          telephone_extension: ''
        },
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        if (this.user_id) {
          this.loadData()
        }
      })
    },
    methods: {
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/users/' + this.user_id).then((response) => {
          this.$validator.detach('password')
          this.user = response.body
          this.user.occurrences = parseInt(response.body.occurrences) === 1
          this.user.reconfirmations = parseInt(response.body.reconfirmations) === 1
          this.user.extend_card = parseInt(response.body.extend_card) === 1
          this.user.move_service_po = parseInt(response.body.move_service_po) === 1
          this.user.delete_service_po = parseInt(response.body.delete_service_po) === 1
          this.user.revert_payment = parseInt(response.body.revert_payment) === 1
          this.user.move_service_invoice = parseInt(response.body.move_service_invoice) === 1
          this.user.delete_service_invoice = parseInt(response.body.delete_service_invoice) === 1
          this.user.validate_charges = parseInt(response.body.validate_charges) === 1
          this.user.generate_boleto = parseInt(response.body.generate_boleto) === 1
          this.user.occurrence_config = parseInt(response.body.occurrence_config) === 1
          this.user.dispute_payment = parseInt(response.body.dispute_payment) === 1
          this.user.refunds_po = parseInt(response.body.refunds_po) === 1
        }, (response) => {

        })
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      save () {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.inProgress = true
            this.error = ''
            let url = this.context.$store.state.config.apiURL + '/users'
            if (this.user_id) {
              url = this.context.$store.state.config.apiURL + '/users/' + this.user_id
            }
            this.context.$http.post(url, this.user).then((response) => {
              this.inProgress = false
              this.close(false, {ok: true, message: 'The user ' + response.body.email + ' was successfully save'})
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// User.vue?69dfdc58